module.exports = __webpack_public_path__ + "static/media/arrow_down.45127ad0.svg";